import { DtoKeys, Services, Helpers } from '@bode-canada/core';

const { SearchListingDtoKey, AddressDtoKey } = DtoKeys;

export default class ListingMapper {
  static mapFromDto(listing) {
    const address = listing[SearchListingDtoKey.ADDRESS];
    return {
      lat: address[AddressDtoKey.LATITUDE],
      lon: address[AddressDtoKey.LONGITUDE],
      addressId: address[AddressDtoKey.ID],
      address: this.#getAddress(address),
      city: address[AddressDtoKey.CITY],
      province: address[AddressDtoKey.STATE],
      community: address[AddressDtoKey.COMMUNITY],
      closedAt: listing[SearchListingDtoKey.CLOSED_AT],
      listingId: listing[SearchListingDtoKey.ID],
      beds: listing[SearchListingDtoKey.BEDS],
      fullBaths: listing[SearchListingDtoKey.BATHS],
      buildingClass: listing[SearchListingDtoKey.BUILDING_CLASS],
      buildingType: listing[SearchListingDtoKey.BUILDING_TYPE],
      finishedSqft: listing[SearchListingDtoKey.TOTAL_FINISH_SQFT],
      price: listing[SearchListingDtoKey.PRICE],
      soldPrice: listing[SearchListingDtoKey.PRICE],
      origin: listing[SearchListingDtoKey.ORIGIN],
      status: listing[SearchListingDtoKey.STATUS],
      listPrice: listing[SearchListingDtoKey.LIST_PRICE],
      daysOnMarket: listing[SearchListingDtoKey.DAYS_ON_MARKET],
      commissionSavings: listing[SearchListingDtoKey.COMMISSION_SAVINGS],
      image: {
        lowResUrl: listing[SearchListingDtoKey.IMAGE_URL],
      },
      halfBaths: 0,
      halfBeds: 0,
    };
  }

  static getFullAddress(address) {
    return Helpers.StringHelper.joinStrings([
      this.#getAddress(address),
      address[AddressDtoKey.CITY],
      address[AddressDtoKey.STATE],
    ], ', ');
  }

  static #getAddress(address) {
    const streetAddress = Services.CleanupAddressService.getAddress(address);

    return Helpers.StringHelper.joinStrings([
      address[AddressDtoKey.UNIT],
      streetAddress,
    ], ' ');
  }
}
